import React, { Component } from "react";
import { connect } from "react-redux";
import { Form as RForm, FormGroup, Label, Input, Button, FormText} from "reactstrap";
import { isEqual } from "lodash";
import Permissions from "../../../Utilities/Permissions";
import API from "../../../Configs";
import * as Helpers from '../../../Utilities/Common';
import Actions from "../../../Actions";

class Form extends Component{
    constructor(props){
        super(props);
        this.permissions = new Permissions(props.permissions);
        const { id = false, name = "", email = "", password = "", role = "", mail_subscription = "", company_id = "" } = props.data;
        this.state = { id, name, email, password, role, mail_subscription, company_id };
    }

    setField = (endpoint, option, type = 0) => {
        Helpers.setField(endpoint, option, type, (dataObj) => this.setState((state) => (dataObj)));
    }

    loadCompanies = () => {
        const { token, companyStore, getCompanies } = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(companyStore.query,query)){
            getCompanies(token,query,false);
        }
    }

    componentDidMount = () => {
        const { can } = this.permissions;
        can("post","companies") ? this.loadCompanies() : "";
    }

    save = (event) => {
        event.preventDefault();
        const { persist, token, permissions, id = '' } = this.props;
        persist(token, this.state, permissions, id);
    }

    render = () => {
        const { blockedField } = this.permissions;
        const { companyStore: { companies }, authRole } = this.props;
        const { id, name, email, password, role, mail_subscription, company_id } = this.state;
        let { "3": adminRole, ...roles } = API.ROLES;
        authRole === 3 ? roles = { ...roles, 3: adminRole } : null;
        return (
                <RForm>
                    <FormGroup>
                        <Label>
                            Name*
                        </Label>
                        <Input onChange={(value) => this.setField("name",value)} value={name} />
                        <FormText color="muted">
                            Maximum 20 characters.
                        </FormText>
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Email*
                        </Label>
                        <Input disabled={id !== false} onChange={(value) => this.setField("email",value)} value={email} />
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Password {id === false && <span>*</span>}
                        </Label>
                        <Input onChange={(value) => this.setField("password",value)} value={password} type="password" />
                        {id !== false && 
                        <FormText color="muted">
                            Leave blank if you don't want to change it.
                        </FormText>
                        }
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Role*
                        </Label>                            
                        <Input onChange={(value) => this.setField("role",value)} value={role} type="select">
                            { Helpers.dropdownItems(roles) }
                        </Input>                            
                    </FormGroup>
                    <FormGroup check>
                        <Label check>
                        <Input type="checkbox" onChange={(value) => this.setField("mail_subscription",value,1)} checked={mail_subscription === 1 ? true : false}/>
                            Mail Subscription*
                        </Label>
                        <br/><br/>                                
                    </FormGroup>
                    {!blockedField("company_id","users") ? 
                    <FormGroup>
                        <Label>
                            Company*
                        </Label>                            
                        <Input disabled={!id ? false: true} onChange={(value) => this.setField("company_id",value)} value={company_id} type="select">{ Helpers.dropdownItems(companies) }</Input>                            
                    </FormGroup>
                    : ""}
                    <FormGroup>
                            <Button block onClick={this.save} color="success" kind="squared">Save</Button>                           
                    </FormGroup>
                </RForm>
        );
    }
}

const mapStateToProps = (state) => ({
    permissions: state.auth.permissions,
    token: state.auth.token,
    authRole: state.auth.user.role,
    companyStore: state.companyStore,
});

export default connect(mapStateToProps, Actions.companies)(Form);



// WEBPACK FOOTER //
// ./src/Components/App/Users/Form.js